import PropTypes from 'prop-types';
import React from 'react';
import { Col, Row } from 'components/Grid';
import { Typography, colors } from '@mui/material';

const styles = {
  icon: {
    marginBottom: 20,
  },
  text: {
    marginBottom: 20,
    textAlign: 'center',
  },
  title: {
    marginBottom: 20,
    textAlign: 'center',
  },
};

const Empty = ({ buttons, icon, style, text, title, ...props }) => (
  <Col {...props} style={style}>
    {icon && (
      <Row centered style={styles.icon}>
        {icon}
      </Row>
    )}
    <Row centered style={styles.title}>
      <Typography fontSize={20} color={colors.orange[600]} style={styles.title}>
        {title}
      </Typography>
    </Row>
    {text && (
      <Row centered style={styles.text}>
        {text}
      </Row>
    )}
    {buttons && <Row centered>{buttons}</Row>}
  </Col>
);

Empty.propTypes = {
  buttons: PropTypes.node,
  icon: PropTypes.node,
  style: PropTypes.object,
  text: PropTypes.string,
  title: PropTypes.string.isRequired,
};

export default Empty;
